export default __webpack_public_path__ + "static/media/Frame.dc98cf25.png";